import { render, staticRenderFns } from "./dirigentes-table.vue?vue&type=template&id=11abda4c&scoped=true"
import script from "./dirigentes-table.vue?vue&type=script&lang=js"
export * from "./dirigentes-table.vue?vue&type=script&lang=js"
import style0 from "./dirigentes-table.vue?vue&type=style&index=0&id=11abda4c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11abda4c",
  null
  
)

export default component.exports